<template>
  <div :class="{ 'message-user': mensaje.role === 'user', 'message-assistant': mensaje.role !== 'user' }">
    <div v-if="mensaje.role === 'user'" class="message-card-user">
      <div v-if="mensaje.tipo == 'texto'" class="p-2 card-body message-details">
        <p class="card-text message-message-user">{{ mensaje.content }}</p>
        <p class="texto-hora">{{ time }}</p>
      </div>
      <div v-else-if="mensaje.tipo == 'audio'" class="card-body" style="border: none;">
        <audio controls class="audio-player">
          <source :src="mensaje.content" type="audio/mpeg">
          Tu navegador no soporta el elemento <code>audio</code>.
        </audio>
        <p class="texto-hora">{{ time }}</p>
      </div>
      <div v-else-if="mensaje.tipo == 'archivos'" class="card-body message-details">
        <p v-if="mensaje.content.mensaje !== ''" class="card-text message-message-user">{{ mensaje.content.mensaje }}
        </p>
        <hr>
        <div v-for="archivo in mensaje.content.archivos" :key="archivo.url">
          <div v-if="archivo.extencion == 'pdf'" class="file-item" @click="showFileView(archivo.url)">
            <span class="material-symbols-outlined icono-archivo">
              picture_as_pdf
            </span>
            {{ archivo.nombre }}
          </div>
          <div v-else class="file-item" @click="showFileView(archivo.url)">
            <span class="material-symbols-outlined icono-archivo">
              image
            </span>
            {{ archivo.nombre }}
          </div>
          <p class="texto-hora">{{ time }}</p>
        </div>
      </div>
    </div>
    <div v-else class="message-card card">
      <div class="card-body message-details p-2">
        <div class="d-flex flex-column">
          <img v-if="mensaje.tipo !== 'texto' && mensaje.content.tipo.includes('image')" :src="mensaje.content.url"
            :class="iframeClases[mensaje.content.tipo] || 'default-iframe-class'"
            @click="showFileView(mensaje.content.url)" />
          <div v-if="mensaje.tipo !== 'texto' && !mensaje.content.tipo.includes('image')">
            <iframe :src="mensaje.content.url" :class="iframeClases[mensaje.content.tipo] || 'default-iframe-class'"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen style="aspect-ratio: 16/9;"></iframe>
          </div>
          <markdown-it-vue v-if="mensaje.tipo == 'texto'" class="md-body markdown-reset" :content="mensaje.content"
            :options="options" />
          <markdown-it-vue v-if="mensaje.content.mensaje !== ''" class="md-body markdown-reset center-text"
            :content="mensaje.content.mensaje" :options="options" />
        </div>
        <template v-if="mensaje.tipo === 'texto' || mensaje.content.mensaje !== ''">
        <button type="button" @click="Reproducir" class="tool-boton m-0 p-0" title="Reproducir respuesta">
          <span class="material-symbols-outlined">
            {{ iconoReproductor }}
          </span>
        </button>
        </template>
        <p class="texto-hora">{{ time }}</p>
      </div>
    </div>
    <FileViewer v-if="showFileContent" :file_url="currentFileUrl" @close="closeFileView"></FileViewer>
  </div>
</template>


<script>
import FileViewer from './FileViewer.vue';
import MarkdownItVue from 'markdown-it-vue'
import axios from 'axios';

export default {
  components: {
    FileViewer,
    MarkdownItVue
  },
  props: {
    mensaje: Object,
    index: Number
  },
  data() {
    return {
      iframeClases: {
        "image/jpeg": "iframe-imagen",
        "image/jpg": "iframe-imagen",
        "image/png": "iframe-imagen",
        "application/pdf": "iframe-pdf",
        "audio/mpeg": "iframe-audio",
      },
      audio: null,
      currentFileUrl: '',
      showFileContent: false,
      iconoReproductor: 'volume_up',
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      options: {
        audio: null,
        reproduciendo: false,
        markdownIt: {
          linkify: true,
          html: true

        },
        linkAttributes: {
          attrs: {
            target: '_blank',
            rel: 'noopener'
          }
        }
      }
    };
  },
  watch: {
    mensaje: {
      handler(newValue) {
        this.revisarContenido(newValue);
      },
      deep: true
    }
  },
  methods: {
    revisarContenido(mensaje) {
      console.log(mensaje)
      console.log("mensaje")
    },
    showFileView(url) {
      this.currentFileUrl = url;
      this.showFileContent = true;
    },
    closeFileView() {
      this.showFileContent = false;
    },
    Reproducir() {
      if (this.audio) {
        if (this.audio.paused) {
          this.iconoReproductor = 'pause';
          this.audio.play();
        } else {
          this.iconoReproductor = 'play_arrow';
          this.audio.pause();
        }
      } else {
        this.iconoReproductor = 'hourglass_empty';
        let cuerpo = {
          mensaje: this.mensaje.tipo == 'texto' ? this.mensaje.content : this.mensaje.content.mensaje,
          id_usuario: localStorage.getItem('id_usuario'),
        }
        axios.post(localStorage.getItem('url') + '/generar_audio', cuerpo, {
          headers: {
            'Content-Type': 'application/json',
          }
        })
          .then(response => {
            const audioUrl = response.data.datos;
            this.audio = new Audio(audioUrl);
            this.iconoReproductor = 'pause';
            this.audio.play();
            this.audio.onended = () => {
              this.iconoReproductor = 'play_arrow';
            };
          })
          .catch(error => {
            this.iconoReproductor = 'volume_up';
            console.error('Error al reproducir el audio:', error);
            alert('Error al reproducir el audio');
          });
      }
    }
  }
};
</script>

<style scoped>
.iframe-imagen {
  width: 70vw;
  border: none;
  display: block;
}

.iframe-pdf {
  width: 100%;
  height: 600px;
  border: none;
}

.iframe-audio {
  width: 100%;
  height: 60px;
  border-radius: 0.5rem;
}

.icono-archivo {
  vertical-align: middle;
  margin-right: 8px;
  width: 100%;
  height: 600;
  font-weight: bold;
  color: #2b8b4b;
}

.default-iframe-class {
  width: 100%;
  height: min-content;
  border-radius: 0.5rem;
}

.center-text{
  text-align: center;
}

@media (max-width: 768px) {
  /* .default-iframe-class,
  img.default-iframe-class {
    max-height: 200px;
  } */

  .default-iframe-class,
img.default-iframe-class {
  max-width: 100%;
  width: auto;
  height: auto;
  max-height: 200px;
  object-fit: contain;
  margin: 10px auto;
  border-radius: 0.5rem;
  display: block;
}

}

@media (min-width: 769px) {
  /* .default-iframe-class,
  img.default-iframe-class {
    max-height: 300px;
  } */

  .default-iframe-class,
img.default-iframe-class {
  max-width: 100%;
  width: auto;
  height: auto;
  max-height: 300px;
  object-fit: contain;
  margin: 10px auto;
  border-radius: 0.5rem;
  display: block;
}

}

.file-item {
  font-weight: bold;
  text-align: left;
  cursor: pointer;
}

.message-card-user {
  margin-bottom: 18px;
  margin-left: auto;
  width: 90%;
  min-width: min-content;
  background-color: transparent;
  border-radius: 0.5rem;
  text-align: right;
  /* Alineación de texto a la derecha */
}

.message-card {
  margin-bottom: 18px;
  background-color: #bad6c8;
  border: none;
  text-align: left;
  width: 90%;
  /* Alineación de texto a la izquierda */
}

.message-details {
  /*color: black;
  font-size: 18px;
  min-width: 100px;*/
  
  font-size: clamp(0.95rem,1.2vw, 1.1rem);
  line-height: 1.5;
  color: #333
}

.message-name-user,
.message-name {
  font-size: 20px;
  font-weight: bold;
  color: black;
}

.message-message-user {
  color: black;
  font-size: 90%;
  margin: 0px;
}

.card-text {
  text-align: left;
}

.message-card-user .message-details {
  background-color: #f7f7f7;
  display: inline-block;
}

.message-card .message-details {
  background-color: transparent;
  display: inline-block;
}

audio {
  width: 100%;
  background-color: #ad5d24;
  border-radius: 0.5rem;
  color: white;
  /* Para cambiar el color de los controles del reproductor */
}

.audio-player {
  width: 100%;
  background-color: #efe2d9;
  border-radius: 0.5rem;
  color: white;
  /* Para cambiar el color de los controles del reproductor */
}

.tool-boton {
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin-right: 0%;
  margin: 0%;
  margin-top: 2%;
  margin-right: 0%;
  margin-left: 0%;
  width: min-content;
  border-radius: 0.5rem;
}

.tool-boton:hover {
  background-color: #929ba354;
  border-color: #646a7019;
}

.tool-boton .material-symbols-outlined {
  font-size: 1.2rem;
  color: black
    /* Tamaño del icono */
}

.texto-hora {
  margin: 0px;
  margin-top: 2px;
  font-size: 10px;
  color: black;
}

.markdown-reset {
  margin: 0;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  word-wrap: break-word;
  /* para que las palabras largas no salgan del contenedor */
  overflow-wrap: break-word;
  overflow: hidden;
}

::v-deep(.markdown-reset *) {
  margin: 0;
}

hr {
  border: 0;
  border-top: 1px solid black;
  margin: 10px 0;
  opacity: 0.8;
}
</style>
